import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import localFont from 'next/font/local'
import { Instrument_Serif } from 'next/font/google'

const satoshi = localFont({
    display: 'swap',
    src: [
        {
            path: '../../public/fonts/satoshi-400.woff2',
            weight: '400',
            style: 'normal'
        },
        {
            path: '../../public/fonts/satoshi-500.woff2',
            weight: '500',
            style: 'normal'
        },
        {
            path: '../../public/fonts/satoshi-700.woff2',
            weight: '700',
            style: 'normal'
        },
        {
            path: '../../public/fonts/satoshi-500-italic.woff2',
            weight: '500',
            style: 'italic'
        }
    ]
})

const instrumentSerif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${satoshi.style.fontFamily};--font-app-mono:ui-monospace,SFMono-Regular,Menlo,monospace;--font-app-heading:${satoshi.style.fontFamily};--font-app-display:${instrumentSerif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
